import { Box, Row, Typography } from '@tempmee/react';
import { colors, shades, shadows } from '@tempmee/tailwind';
import { DSBackButton } from '~/components/shared/DSBackButton';
import { ShiftPendingReviews } from './ShiftPendingReviews';

// Matches FloatingContainer default shadow (legacy: '0px 1px 3px rgba(0, 0, 0, 0.2)').
const FLOATING_SHADOW = shadows['elevation-4'];

export const ShiftPendingReviewsScreen = () => (
  <Box style={{ backgroundColor: colors.neutral[100], flex: 1 }}>
    <Box
      style={{
        backgroundColor: shades[0],
        borderRadius: 10,
        boxShadow: FLOATING_SHADOW,
        flexDirection: 'column',
        margin: 25,
        minWidth: 800,
        padding: 10,
      }}
    >
      <Row
        align="center"
        justify="center"
        style={{ marginBottom: 32, marginTop: 44, position: 'relative' }}
      >
        <Box style={{ position: 'absolute', left: 0 }}>
          <DSBackButton />
        </Box>
        <Typography size="heading_2" bold>
          Pending Review
        </Typography>
      </Row>
      <Box px={8}>
        <ShiftPendingReviews />
      </Box>
    </Box>
  </Box>
);
